export const dark = {
  colors: {
    fontColor: "#e4e4e4",
    bgColor: "#1f1f1f",
  },
};

export const light = {
  colors: {
    fontColor: "#000",
    bgColor: "#fff",
  },
};
